import React from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const TablaCalculos = (props) => {
    const TITULO = "Cesantia Vejez Patronal";
    const { datos } = props;
    return (
        <div>
            <DataTable value={datos} responsive={true} header={TITULO} autoLayout={true}>
                <Column header="Valor Mínimo" field="tcCesantiavejezPatronal.valorMinimo" />
                <Column header="Tipo de Valor" field="tcCesantiavejezPatronal.tipoValorMinimo" />
                <Column header="Valor Máximo" field="tcCesantiavejezPatronal.valorMaximo" />
                <Column header="Tipo Valor" field="tcCesantiavejezPatronal.tipoValorMaximo" />
                <Column header="SBC Mínimo" field="minimo" />
                <Column header="SBC Máximo" field="maximo" />
                <Column header="% Patronal" field="tcCesantiavejezPatronal.porcentaje" />
                <Column header="Año" field="ttCalculocesantiavejezAnual.anio" />
                <Column header="SM" field="ttCalculocesantiavejezAnual.salarioMinimo" />
                <Column header="UMA" field="ttCalculocesantiavejezAnual.uma" />
            </DataTable>
        </div>
    );
}